import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { DeviceContext } from "../context/deviceContext";
import NavigationProp from "../props/navigationProp";
import MobileNavigation from "./mobileNavigation";

export default function Header() {

    const {isMobile} = useContext(DeviceContext);

    return(
        <>
            <header>
                <div className="logoContainer">

                    {/* Logo Container */}
                    <div className="logo"></div>

                    {/* Company Name */}
                    <div className="companyName">
                        <Link to={'/'} className={`navLink nameNavLink ${isMobile && 'phoneNavLink'}`}>BidBrick</Link>
                    </div>
                </div>

                {isMobile ? (<MobileNavigation />):(<NavigationProp />)}

                
                
            </header>
        </>

    );
}